import  React from 'react';
import { config } from "../../config";
import { Container, Col, Row } from "reactstrap"
import { addBodyClasses} from "../utils";

const queryString = require('query-string');

function WebRetroDownload() {
  const parsed = queryString.parse(window.location.search);
  const edition = parsed.edition || 'measure';
  const pid = parsed.pid;
  const c = parsed.c;
  const onboard_template = parsed.onboard_template || 'default';
  const source = parsed.source;
  const community_slug = parsed.community_slug || 'msr';

  let title = 'Welcome to MSR';
  if (community_slug.includes('arno')) {
    title = 'Welcome to MSR-meant';
  }

  const downloadUrl = `${config.CONTRIBUTOR_API_ENDPOINT}/download?mode=af&edition=${edition}&onboard_template=${onboard_template}`;

  addBodyClasses(['download-page'])();



  return (

    <Container fluid="sm">
      {source === "nextdoor" &&
        <img className="hide" height="1" width="1" src="https://flask.nextdoor.com/pixel?pid=90e78a85-50ea-45e7-979e-697bbeb972fc&ev=CONVERSION&noscript=1" />
      }

      {source === "pinchme" &&
        <iframe src="https://offers.pinchme.com/aff_l?offer_id=2745" scrolling="no" frameBorder="0" width="1" height="1"></iframe>
      }

      <Row>
        <Col>
          <img className="tick-icon" src="/img/circle-tick-white.svg" alt="Welcome to MSR" />
          <h1>{title}</h1>
            <p>Your account has been created.</p>


            <p>
                <strong>On your mobile device?</strong>
                <br/>Tap below to install the MSR app.
                <span className="action-button">
                    <a className="btn btn-primary" href={downloadUrl} target="_blank">Download MSR</a>
                </span>
            </p>

            <p>
                <strong>On your desktop?</strong>
                <br/>Open the camera app on your mobile device, and point it at the QR code below.
                <span className="action-button">
                    {community_slug.includes("arno") &&
                        <img src="https://d3s00xghdjywqy.cloudfront.net/c2/qr/qr_arno_2.png" className="qr"/>
                    }

                    {!community_slug.includes("arno") &&
                        <img src="https://d3s00xghdjywqy.cloudfront.net/c2/qr/default.png" className="qr"/>
                    }
                </span>
            </p>


        </Col>
      </Row>
    </Container>
  );
}

export default WebRetroDownload;
